var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapMap',{attrs:{"center":{ lat: this.mapData.latitude, lng: this.mapData.longitude },"zoom":18,"map-type-id":"terrain","options":{
    zoomControl: true,
    mapTypeControl: true,
    scaleControl: true,
    streetViewControl: true,
    rotateControl: true,
    fullscreenControl: true,
    disableDefaultUi: true,
  },"id":"Gmaps"}},[_c('GmapMarker',{attrs:{"position":this.mapData.position,"clickable":true,"draggable":false,"content":"aa"},on:{"click":function($event){_vm.show = !_vm.show}}},[_c('GmapInfoWindow',{attrs:{"opened":_vm.show},on:{"closeclick":function($event){_vm.show = false}}},[_vm._v(_vm._s(this.mapData.address))])],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }